module.exports = __webpack_public_path__ + "static/media/brands.953f526e.png";